// import React, { Component } from 'react';
// import { acessarSistema, ListaTelasCRM, runVerificaAutenticacao } from '../../services/api';
// import { Link } from 'react-router-dom';
// import { InputGroup, InputRightElement, Input, Button, InputLeftElement } from '@chakra-ui/react';
// import '../../sass/acesso-usuario.scss';
// import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
// import {
//   ButtonHidePassword,
//   CheckBoxContainer,
//   Container,
//   Container2,
//   Container3,
//   Container4,
//   Container5,
//   Container6,
//   Container7,
//   Container8,
//   ContainerCentralizar,
//   LdsEllipsisFormLogin,
//   Logo
// } from './styles';
// import { FaUserCircle } from 'react-icons/fa';
// import { IoIosLock } from 'react-icons/io';

// class Login extends Component {
//   constructor(props) {
//     super(props);

//     this.state = {
//       email_usuario: null,
//       senha_usuario: null,
//       manter_conectado: false,
//       loading: false
//     };
//   }

//   componentDidMount() {
//     if (localStorage.getItem('manter_conectado') != null) {
//       var dados = JSON.parse(atob(localStorage.getItem('manter_conectado')));
//       this.setState({
//         email_usuario: dados.email,
//         senha_usuario: dados.senha,
//         manter_conectado: true
//       });
//       document.getElementById('email').value = dados.email;
//       document.getElementById('pwd').value = dados.senha;
//     } else {
//       this.setState({
//         email_usuario: null,
//         senha_usuario: null,
//         manter_conectado: false
//       });
//     }
//   }

//   handleClick = () =>
//     this.setState({
//       show: !this.state.show
//     });

//   onChangeInput = async (e, value) => {
//     if (value == 'manter_conectado') {
//       this.setState({ manter_conectado: !this.state.manter_conectado });
//     } else {
//       this.setState({ [value]: e.target.value });
//     }
//   };

//   getAcessarSistema = async () => {
//     this.setState({ loading: true });
//     await new Promise((resolve) => setTimeout(resolve, 2000));
//     try {
//       if (this.state.email_usuario == '') {
//         alert('Preencha o campo de email');
//       } else if (this.state.senha_usuario == '') {
//         alert('Preencha o campo de senha');
//       } else {
//         if (this.state.manter_conectado) {
//           localStorage.setItem(
//             'manter_conectado',
//             btoa(
//               JSON.stringify({
//                 email: this.state.email_usuario,
//                 senha: this.state.senha_usuario
//               })
//             )
//           );
//         } else {
//           if (localStorage.getItem('manter_conectado') != null)
//             localStorage.removeItem('manter_conectado');
//         }

//         var param = {
//           email: this.state.email_usuario,
//           senha: this.state.senha_usuario
//         };

//         const response = await acessarSistema.post('', param);
//         var dados = response.data;

//         localStorage.setItem('authentication', JSON.stringify(dados));

//         try {
//           const responseTelas = await ListaTelasCRM.get();
//           var dadostela = responseTelas.data;

//           localStorage.setItem('telascarregadas', JSON.stringify(dadostela));

//           if (JSON.parse(localStorage.getItem('authentication'))) {
//             var permissoes = JSON.parse(localStorage.getItem('authentication')).permissoes_usuario;
//             var telas = JSON.parse(localStorage.getItem('telascarregadas'));

//             for (var perm in permissoes) {
//               if (permissoes[perm].telainicial == 'S') {
//                 window.location.href = telas[perm].link_menu;
//               }
//             }
//           }
//         } catch (error) {
//           alert('Erro ao acessar sistema!');
//           this.setState({ loading: false });
//           console.log(Object.keys(error), error.message);
//         }
//       }
//     } catch (error) {
//       alert('Erro ao acessar sistema!');
//       this.setState({ loading: false });
//       console.log(Object.keys(error), error.message);
//     }
//   };

//   render() {
//     const { loading } = this.state;
//     return (
//       <Container>
//         <ContainerCentralizar>
//           <Container2>
//             <Container3>
//               <Container4></Container4>
//               <Container5>
//                 <Logo alt="logo" />
//                 <Container6>
//                   <InputGroup>
//                     <InputLeftElement
//                       pointerEvents="none"
//                       color="gray.300"
//                       fontSize="1.3em"
//                       left="35px"
//                       top="15px"
//                       children={<FaUserCircle color="#92ba1f" />}
//                     />
//                     <Input
//                       fontFamily="Akrobat, sans-serif"
//                       position="relative"
//                       left="8%"
//                       letterSpacing="1px"
//                       borderRight="none"
//                       borderBottom="none"
//                       borderTop="none"
//                       borderLeft="5px solid #92ba1f"
//                       color="rgba(0, 0, 0, 0.7)"
//                       paddingLeft="45px"
//                       marginTop="8px"
//                       fontSize="20px"
//                       backgroundColor="rgb(240, 240, 240)"
//                       opacity="1"
//                       width="80%"
//                       height="50px"
//                       _hover={{
//                         borderLeft: '5px solid #92ba1f',
//                         opacity: '0.9'
//                       }}
//                       autoFocus
//                       focusBorderColor="#92ba1f"
//                       id="email"
//                       type="text"
//                       placeholder="E-mail"
//                       onKeyPress={(e) => (e.key == 'Enter' ? this.getAcessarSistema() : null)}
//                       onChange={(e) => this.onChangeInput(e, 'email_usuario')}
//                     />
//                     <InputRightElement />
//                   </InputGroup>

//                   <InputGroup size="md">
//                     <InputLeftElement
//                       pointerEvents="none"
//                       color="gray.300"
//                       fontSize="1.5em"
//                       left="35px"
//                       top="15px"
//                       children={<IoIosLock color="#92ba1f" />}
//                     />
//                     <Input
//                       paddingLeft="45px"
//                       fontFamily="Akrobat, sans-serif"
//                       position="relative"
//                       left="8%"
//                       borderRight="none"
//                       borderBottom="none"
//                       borderTop="none"
//                       borderLeft="5px solid #92ba1f"
//                       color="rgba(0, 0, 0, 0.7)"
//                       marginTop="8px"
//                       fontSize="20px"
//                       letterSpacing="1px"
//                       backgroundColor="rgb(240, 240, 240)"
//                       opacity="1"
//                       width="80%"
//                       height="50px"
//                       _hover={{
//                         borderLeft: '5px solid #92ba1f',
//                         opacity: '0.9'
//                       }}
//                       onKeyPress={(e) => (e.key == 'Enter' ? this.getAcessarSistema() : null)}
//                       focusBorderColor="#92ba1f"
//                       id="pwd"
//                       type={this.state.show ? 'text' : 'password'}
//                       placeholder="Senha"
//                       onChange={(e) => this.onChangeInput(e, 'senha_usuario')}
//                     />
//                     <InputRightElement width="5rem">
//                       <ButtonHidePassword
//                         colorScheme="white"
//                         size="md"
//                         boxShadow="none !important"
//                         onClick={() => this.handleClick()}>
//                         {this.state.show ? (
//                           <AiFillEyeInvisible
//                             height={100}
//                             width={100}
//                             position="relative"
//                             color="#92ba1f"
//                           />
//                         ) : (
//                           <AiFillEye height={100} width={100} position="relative" color="#92ba1f" />
//                         )}
//                       </ButtonHidePassword>
//                     </InputRightElement>
//                   </InputGroup>
//                 </Container6>
//                 <Container7>
//                   <CheckBoxContainer>
//                     <input
//                       checked={this.state.manter_conectado ? true : false}
//                       type="radio"
//                       onClick={(e) => this.onChangeInput(e, 'manter_conectado')}
//                     />
//                     <label>Manter conectado?</label>
//                   </CheckBoxContainer>
//                 </Container7>
//                 <Container8>
//                   <Button
//                     boxShadow="none !important"
//                     w="95%"
//                     h="100%"
//                     borderRadius="40px"
//                     fontSize="16px"
//                     fontFamily="Akrobat ExtraBold"
//                     color="white"
//                     letterSpacing="1px"
//                     bgColor="#92ba1f"
//                     cursor="pointer"
//                     opacity="0.9"
//                     _hover={{
//                       bgColor: '#92ba1f',
//                       opacity: '1'
//                     }}
//                     onClick={() => this.getAcessarSistema()}>
//                     {loading ? (
//                       <LdsEllipsisFormLogin class="lds-ellipsis">
//                         <div></div>
//                         <div></div>
//                         <div></div>
//                         <div></div>
//                       </LdsEllipsisFormLogin>
//                     ) : (
//                       <span>ENTRAR</span>
//                     )}
//                   </Button>
//                 </Container8>
//               </Container5>
//             </Container3>
//           </Container2>
//         </ContainerCentralizar>
//       </Container>
//     );
//   }
// }

// export default Login;

import { NewLogin } from '../NewLogin'

export const Login = () => {
  return <NewLogin />
}

export default Login
